import React from "react";

import { Page } from "../../../components";
import theme from "../../../theme";
import LoadingBlock from "../../LoadingBlock";

export default (): JSX.Element => (
  <Page
    id="page-wrap"
    backgroundColor={theme.colors.white}
    horizontalPadding={0}
    pageType="loading"
    noFooter
  >
    <LoadingBlock />
  </Page>
);
